/* import __COLOCATED_TEMPLATE__ from './user-visibility-bot-changes-body.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();